import { render, staticRenderFns } from "./Configuration.vue?vue&type=template&id=0046b4fd&scoped=true"
import script from "./Configuration.vue?vue&type=script&lang=js"
export * from "./Configuration.vue?vue&type=script&lang=js"
import style0 from "./Configuration.vue?vue&type=style&index=0&id=0046b4fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0046b4fd",
  null
  
)

export default component.exports